import { ReactNode, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { BiChevronsRight, BiChevronsLeft } from 'react-icons/bi';
import { BsFillHouseFill } from 'react-icons/bs';
import Logo from '../../../assets/images/logo_bg.png';
import { SCRIPTS_PATH } from '~/services/endpoints';
import { LABELS } from '~/resources/Labels';

interface MenuProps {
  children?: ReactNode;
}

export const SIMPLMenuHeader = ({ children }: MenuProps) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  return (
    <div className="flex flex-col h-screen relative">
      {/* Top Menu */}
      <div className="flex justify-start items-center bg-[#002B6E] text-white px-6 py-3 relative">
        <div className="flex items-center justify-start w-full">
          <img src={Logo} alt="Logo" className="h-20" />
        </div>
      </div>

      {/* Main Content Wrapper */}
      <div className="flex flex-1 relative">
        {/* Sidebar - Expand/Shrink */}
        <div
          className={`bg-[#002B6E] ${
            isSidebarExpanded
              ? 'w-[240px]'
              : 'w-[60px] rounded-tr-[20px] rounded-br-[20px]'
          } 
  p-5 text-white transition-all duration-300 flex flex-col ml-auto overflow-hidden relative`}
        >
          <span className="h-[15px]"></span>
          {/* Sidebar Toggle and Menu Text */}
          <div className="flex items-center justify-between mb-8">
            {/* Menu Text */}
            <span
              className={`${isSidebarExpanded ? 'inline-flex items-center' : 'hidden'} 
              text-sm font-semibold`}
            >
              <BsFillHouseFill size={22} className="mr-1" />
              Menu
            </span>

            {/* Sidebar Toggle Button - Now Positioned on the Right */}
            <button
              onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
              className="ml-auto w-[22px] h-[20px] gap-8 rounded-md border-[1px] border-[#51E7F9] 
              p-4 flex items-center justify-center transition-all duration-300"
            >
              {isSidebarExpanded ? (
                <span className="text-sm font-semibold text-[#51E7F9]">
                  <BiChevronsLeft size={14} />
                </span>
              ) : (
                <span className="text-sm font-semibold text-[#51E7F9]">
                  <BiChevronsRight size={14} />
                </span>
              )}
            </button>
          </div>

          <nav className="flex-1">
            <ul className="space-y-3">
              <li className="mb-2 flex items-center">
                <NavLink
                  to={SCRIPTS_PATH}
                  className={({ isActive }) => {
                    if (!isSidebarExpanded) return '';

                    const baseStyles =
                      'text-sm font-semibold text-white flex items-center px-4 py-2 rounded-md transition-all border w-full whitespace-nowrap';
                    const activeStyles =
                      'bg-opacity-10 bg-[#51E7F9] border-[#51E7F9] border-[1px] text-[#51E7F9]';
                    const inactiveStyles = 'border-transparent text-white';
                    const hoverStyles =
                      'hover:border-[#51E7F9] hover:bg-opacity-10 hover:bg-[#51E7F9]  hover:border-[1px] hover:text-[#51E7F9]';

                    return `${baseStyles} ${isActive ? activeStyles : inactiveStyles} ${hoverStyles}`;
                  }}
                >
                  <span
                    className={`text-[14px] leading-[16px] tracking-[0%] align-middle 
                    ${isSidebarExpanded ? 'inline' : 'hidden'} whitespace-nowrap flex-1`}
                  >
                    {LABELS.DeploymentScript}
                  </span>
                </NavLink>
              </li>

              <li className="mb-2 flex items-center">
                <NavLink
                  to="/contracts"
                  className={({ isActive }) => {
                    if (!isSidebarExpanded) return '';

                    const baseStyles =
                      'text-sm font-semibold text-white flex items-center px-4 py-2 rounded-md transition-all border w-full whitespace-nowrap';
                    const activeStyles =
                      'bg-opacity-10 bg-[#51E7F9] border-[#51E7F9] border-[1px] text-[#51E7F9]';
                    const inactiveStyles = 'border-transparent text-white';
                    const hoverStyles =
                      'hover:border-[#51E7F9] hover:bg-opacity-10 hover:bg-[#51E7F9] hover:border-[1px] hover:text-[#51E7F9]';

                    return `${baseStyles} ${isActive ? activeStyles : inactiveStyles} ${hoverStyles}`;
                  }}
                >
                  <span
                    className={`text-[14px] leading-[16px] tracking-[0%] align-middle 
                    ${isSidebarExpanded ? 'inline' : 'hidden'} whitespace-nowrap flex-1`}
                  >
                    {LABELS.Contract}
                  </span>
                </NavLink>
              </li>
               <li className="mb-2 flex items-center">
                <NavLink
                  to="/cloud-environment"
                  className={({ isActive }) => {
                    if (!isSidebarExpanded) return '';

                    const baseStyles =
                      'text-sm font-semibold text-white flex items-center px-4 py-2 rounded-md transition-all border w-full whitespace-nowrap';
                    const activeStyles =
                      'bg-opacity-10 bg-[#51E7F9] border-[#51E7F9] border-[1px] text-[#51E7F9]';
                    const inactiveStyles = 'border-transparent text-white';
                    const hoverStyles =
                      'hover:border-[#51E7F9] hover:bg-opacity-10 hover:bg-[#51E7F9] hover:border-[1px] hover:text-[#51E7F9]';

                    return `${baseStyles} ${isActive ? activeStyles : inactiveStyles} ${hoverStyles}`;
                  }}
                >
                  <span
                    className={`text-[14px] leading-[16px] tracking-[0%] align-middle 
                    ${isSidebarExpanded ? 'inline' : 'hidden'} whitespace-nowrap flex-1`}
                  >
                    {LABELS.CloudEnviroment}
                  </span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>

        {/* Page Content */}
        <div className="p-6 flex-1">
          {Array.isArray(children)
            ? children.map((child, index) => <div key={index}>{child}</div>)
            : children}
        </div>
      </div>
    </div>
  );
};
